import { render, staticRenderFns } from "./SalarySlipPDFView.vue?vue&type=template&id=e8b87f32&scoped=true"
import script from "./SalarySlipPDFView.vue?vue&type=script&lang=js"
export * from "./SalarySlipPDFView.vue?vue&type=script&lang=js"
import style0 from "./SalarySlipPDFView.vue?vue&type=style&index=0&id=e8b87f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b87f32",
  null
  
)

export default component.exports